import {
    post,
    get,
    put,
    delete1
} from '../../http/index'
import Cookies from "js-cookie";

const TOKEN_VALID_KEY = "jwt_token_valid";

const request = {
  state: {
    token: '',
    projectId: '',
    userInfo: '',
    jwtToken: Cookies.get(TOKEN_VALID_KEY)
      ? localStorage.getItem("jwtToken") || ""
      : "",
    appId: '',
    admin: '',
    loginUserInfo: {
      account: "",
      password: "",
      rememberPassword: false,
    },
  },
  mutations: {
    getToken: (state, data) => {
      state.token = data
    },
    getProjectId: (state, data) => {
      state.projectId = data
    },
    getAppId: (state, data) => {
      state.appId = data
    },
    getSuperAdmin: (state, data) => {
      state.admin = data
    },
    getUserInfo: (state, data) => {
      state.userInfo = data
    },
    getJwtToken: (state, data) => {
      state.jwtToken = data;
      if (data) {
        localStorage.setItem("jwtToken", data);
        Cookies.set(TOKEN_VALID_KEY, "1", {
          expires: new Date(Date.now() + 8 * 60 * 60 * 1000),
        });
      } else {
        localStorage.removeItem("jwtToken");
        Cookies.remove(TOKEN_VALID_KEY);
      }
    },
    setLoginInfo: (state, data) => {
      state.loginUserInfo = data;
    },
  },
  // 异步方法
  actions: {
    // post请求
        httpPost({
                     commit,
                     state
                 }, _data) {
            const curl = _data.curl
            delete _data.curl
            const data = _data
            return new Promise((resolve, reject) => {
                post({
                    // url: curl.indexOf("http://") != -1 || curl.indexOf("https://") != -1 ? curl :  window.configUrl + curl,
                    url: curl,
                    data: data
                }, function (res) {
                    resolve(res)
                }, function (err, message) {
                    reject(err)
                })
            })
        },
        // put请求
        httpPut({
                    commit,
                    state
                }, _data) {
            const curl = _data.curl
            delete _data.curl
            const data = _data
            return new Promise((resolve, reject) => {
                put({
                    // url: curl.indexOf("http://") != -1 || curl.indexOf("https://") != -1 ? curl :  window.configUrl + curl,
                    url: curl,
                    data: data
                }, function (res) {
                    resolve(res)
                }, function (err, message) {
                    reject(err)
                })
            })
        },
        // delete请求
        httpDelete({
                       commit,
                       state
                   }, _data) {
            const curl = _data.curl
            delete _data.curl
            const data = _data
            return new Promise((resolve, reject) => {
                delete1({
                    // url: curl.indexOf("http://") != -1 || curl.indexOf("https://") != -1 ? curl :  window.configUrl + curl,
                    url: curl,
                    data: data
                }, function (res) {
                    resolve(res)
                }, function (err, message) {
                    reject(err)
                })
            })
        },
        // get请求
        httpGet({
                    commit,
                    state
                }, _data) {
            const curl = _data.curl
            delete _data.curl
            const data = _data
            return new Promise((resolve, reject) => {
                get({
                    //url: curl.indexOf("http://") != -1  || curl.indexOf("https://") != -1 ? curl :  window.configUrl + curl,
                    url: curl,
                    data: data
                }, function (res) {
                    resolve(res)
                }, function (err, message) {
                    reject(err)
                })
            })
        },
        loginByAccount({ commit }, payload) {
            return new Promise((resolve, reject) => {
                post(
                {
                    url: "/api/user/login",
                    headers: {
                    "Auth-Type": "DB",
                    },
                    data: payload,
                },
                function (res) {
                    commit("getJwtToken", res.token);
                    commit("getUserInfo", {
                        token: res.token,
                        account: res.data.account,
                        userName: res.data.name,
                        roles: res.data.roles,
                    });
                    resolve(res);
                },
                function (err) {
                    reject(err);
                }
                );
            });
        },
        rememberLoginInfo({ commit }, userInfo) {
            commit("setLoginInfo", userInfo);
        },
        loginOut({ commit }) {
            return new Promise((resolve) => {
                commit("getJwtToken", "");
                commit("getUserInfo", "");
                resolve();
            });
        },
  }
}

export default request
